import { combineReducers } from 'redux';

import isWaiting from './network';
import auth from './auth';
import registration from './registration';
import trialregistration from './trialregistration';
import singleregistration from './singleregistration';
import joinGroup from './joinGroup';
import subscriptions from './subscriptions';
import invoices from './invoices';
import exercises from './exercises';
import group from './group';
import text from './text';
import history from './history';
import validation from './validation';

const appReducer = combineReducers({
  isWaiting,
  auth,
  registration,
  trialregistration,
  singleregistration,
  joinGroup,
  subscriptions,
  invoices,
  group,
  exercises,
  text,
  history,
  validation,
});

const rootReducer = (state, action) => {
  let returnedState = state;
  if (action.type === 'LOGOUT_SUCCESS' || action.type === 'LOGOUT_FAIL') {
    returnedState = undefined;
  }

  return appReducer(returnedState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js